import { render } from "./notification_management.html?vue&type=template&id=66d9d16a&external"
import script from "./notification_management.js?vue&type=script&lang=js&external"
export * from "./notification_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__